import type { FormDataOf, FormDataValue } from '../../../../../types/templates';
import { disneyEspnVS } from '..';
import { applyESPNLogic } from './espn-form-handlers';
import { getMatchData } from './get-match-data';

type FormData = FormDataOf<typeof disneyEspnVS>;

export const applyFieldLogic = (fieldKey: string, value: FormDataValue, formData: FormData): Partial<FormData> => {
  const updates: Partial<FormData> = {};

  // 1. General ESPN logic (time sync, sport change)
  Object.assign(updates, applyESPNLogic(fieldKey, value, formData));

  // 2. Auto-fill match data when team2 is picked
  if (fieldKey === 'team2' && value) {
    const creativityType = (formData as FormData & { _creativityType?: string })._creativityType;
    const matchData = getMatchData({ ...formData, team2: value as string }, creativityType);

    if (matchData) {
      const fieldsToAutoComplete = [
        'date',
        'day',
        'region1',
        'region2',
        'region3',
        'region4',
        'time1',
        'time2',
        'time3',
        'time4'
      ] as const;

      fieldsToAutoComplete.forEach(field => {
        const fieldValue = matchData[field as keyof typeof matchData];
        if (!formData[field] && fieldValue) {
          updates[field] = fieldValue;
        }
      });
    }
  }

  return updates;
};
